//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import activiteit from '~/graphql/queries/activiteit.gql';
import aanmeldingen from '~/graphql/queries/aanmeldingen.gql';
import aanmeldenActiviteit from '~/graphql/mutations/aanmeldenActiviteit.gql';
import uniqueEmailCheck from '~/graphql/queries/uniqueEmailCheck.gql';
import {PAYMENT_TYPES} from '~/plugins/constants';

export default {
  auth: false,
  apollo: {
    activiteit: {
      query: activiteit,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result({data}) {
        this.$nextTick(() => {
          if (!data?.activiteit && !this.errorShown) {
            if (this.$toast) {
              this.$toast.error('Activiteit niet gevonden.');
            }
            this.$router.push('/');
            this.errorShown = true;
          }
        });
      },
    },
    aanmeldingen: {
      query: aanmeldingen,
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  data: () => ({
    formData: {},
    openForm: false,
    activiteit: null,
    aanmeldingen: [],
    showPopup: false,
    errorShown: false,
    userExists: false,
    PAYMENT_TYPES,
  }),
  computed: {
    paymentOptions() {
      if (this.$auth.loggedIn && this.$auth.user.is_werkgroeplid_coordinator) {
        return {[PAYMENT_TYPES.IDEAL]: 'iDeal (Mollie payments)', [PAYMENT_TYPES.WERKGROEPLID_COORDINATOR]: 'Gratis (Werkgroeplid–Coördinator)'};
      } else {
        return {[PAYMENT_TYPES.IDEAL]: 'iDeal (Mollie payments)'};
      }
    },
    paymentRequired() {
      return this.price > 0;
    },
    validAuth() {
      const parts = ['voornaam', 'achternaam', 'e_mailadres', 'telefoonnummer', 'adres', 'huisnummer', 'postcode', 'plaats'];
      return this.$auth.loggedIn && parts.every(part => this.$auth.user[part]);
    },
    signedUpAlready() {
      let signedUp = false;
      if (this.activiteit && this.aanmeldingen.length) {
        this.aanmeldingen.forEach((aanmelding) => {
          if (aanmelding.activiteit.id === this.activiteit.id) {
            signedUp = true;
          }
        });
      }
      return signedUp;
    },
    price() {
      if (this.$auth.loggedIn && this.activiteit.perfectview_scholing?.kosten) {
        return this.activiteit.perfectview_scholing.kosten;
      }
      return this.activiteit.perfectview_scholing_particulier?.kosten ?? 0.0;
    },
  },
  mounted() {
    this.formData = {
      voornaam: this.$auth.loggedIn ? this.$auth.user.voornaam : null,
      tussenvoegsel: this.$auth.loggedIn ? this.$auth.user.tussenvoegsel : null,
      achternaam: this.$auth.loggedIn ? this.$auth.user.achternaam : null,
      geslacht: this.$auth.loggedIn ? this.$auth.user.geslacht : null,
      email: this.$auth.loggedIn ? this.$auth.user.e_mailadres : null,
      telefoonnummer: this.$auth.loggedIn ? this.$auth.user.telefoonnummer : null,
      adres: this.$auth.loggedIn ? this.$auth.user.adres : null,
      huisnummer: this.$auth.loggedIn ? this.$auth.user.huisnummer : null,
      toevoeging: this.$auth.loggedIn ? this.$auth.user.toevoeging : null,
      postcode: this.$auth.loggedIn ? this.$auth.user.postcode : null,
      plaats: this.$auth.loggedIn ? this.$auth.user.plaats : null,
    };

    if (this.$route.query.p) {
      this.showPopup = true;
      this.$router.push(this.$route.path);
    }

    setTimeout(() => {
      this.openForm = typeof this.$route.query.deelnemen !== 'undefined';
    }, 1000);
  },
  methods: {
    goToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    async checkIfUserExists(request) {
      if (this.$auth.loggedIn || (!this.formData?.email || this.formData.email.length < 5)) {
        this.aanmelden(request);
        return;
      }
      await this.$apollo.query({
        query: uniqueEmailCheck,
        variables: {
          email: this.formData.email,
        },
      }).then((data) => {
        if (!data.data.uniqueEmailCheck) {
          this.$toast.error('U bent lid van het NVPA, log in en meld u aan via het dashboard.');
          this.userExists = true;
        } else {
          this.userExists = false;
          this.aanmelden(request);
        }
      });
    },
    async aanmelden(request) {
      try {
        if (typeof request.huisnummer === 'string') {
          request.huisnummer = Number.parseInt(request.huisnummer, 10);
        }
        const data = {
          adres: request.adres,
          huisnummer: request.huisnummer,
          toevoeging: request.toevoeging,
          postcode: (request.postcode).toUpperCase().replace(' ', ''),
          plaats: request.plaats,
          voornaam: request.voornaam,
          tussenvoegsel: request.tussenvoegsel,
          achternaam: request.achternaam,
          geslacht: request.geslacht,
          activiteit_id: this.activiteit.id,
          activiteit_prijs: this.price,
          betalingswijze: this.paymentRequired ? request.betalingswijze : PAYMENT_TYPES.GRATIS,
          redirect: this.$route.path,
          telefoonnummer: request.telefoonnummer,
          email: request.email,
          opmerking: request.opmerking,
        };
        const response = await this.$apollo.mutate({
          mutation: aanmeldenActiviteit,
          variables: data,
          refetchQueries: ['aanmeldingen'],
        });
        const url = response.data.aanmeldenActiviteit;
        if (url) {
          location.replace(url);
        } else {
          this.$toast.success('U bent aangemeld voor de activiteit.');
          this.openForm = false;
          this.goToTop();
        }
      } catch (err) {
        this.$toast.error(err);
      }
    },
  },
  head() {
    return {
      title: this.activiteit?.title || 'Activiteit',
    };
  },
};
